// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1KMin","select":"Header_select__2DuJk","clinic":"Header_clinic__FAsYW"};